import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { ListForm } from '../../../../base/controlers/list-form';
import { DoorType } from '../../models/door-type';
import { DoorTypeService } from '../../services/door-type.service';

@Component({
  selector: 'app-door-type-list',
  templateUrl: './door-type-list.component.html',
  styleUrls: ['./door-type-list.component.css']
})
export class DoorTypeListComponent extends ListForm<DoorType> implements OnInit {
  public displayedColumns = ['actions','code','name'];
  constructor(
    protected doorTypeService: DoorTypeService,
    protected router:Router
  ) {
    super(doorTypeService,'/plasard-measurement/door-type',router);
   }

  ngOnInit() {
    super.ngOnInit();
  }

}
